/** A tiny 3×5 pixel font for in-world signs, markers and labels. */

import type { Px } from './pixel';

const G: Record<string, string> = {
  '0': '111101101101111',
  '1': '010110010010111',
  '2': '111001111100111',
  '3': '111001111001111',
  '4': '101101111001001',
  '5': '111100111001111',
  '6': '111100111101111',
  '7': '111001010010010',
  '8': '111101111101111',
  '9': '111101111001111',
  A: '010101111101101',
  B: '110101110101110',
  C: '111100100100111',
  D: '110101101101110',
  E: '111100110100111',
  F: '111100110100100',
  G: '111100101101111',
  H: '101101111101101',
  I: '111010010010111',
  J: '001001001101111',
  K: '101101110101101',
  L: '100100100100111',
  M: '101111111101101',
  N: '110101101101101',
  O: '111101101101111',
  P: '111101111100100',
  Q: '111101101111001',
  R: '110101110101101',
  S: '111100111001111',
  T: '111010010010010',
  U: '101101101101111',
  V: '101101101101010',
  W: '101101111111101',
  X: '101101010101101',
  Y: '101101010010010',
  Z: '111001010100111',
  '.': '000000000000010',
  ',': '000000000010100',
  ':': '000010000010000',
  '-': '000000111000000',
  '+': '000010111010000',
  '!': '010010010000010',
  '?': '111001010000010',
  '/': '001001010100100',
  '%': '101001010100101',
  ' ': '000000000000000',
  "'": '010010000000000',
  '#': '101111101111101',
  '★': '010111111010101',
  '<': '001010100010001',
  '>': '100010001010100',
};

/** Draw text at (x, y) top-left; returns the width drawn. `scale` repeats pixels. */
export function pixelText(px: Px, x: number, y: number, text: string, color: string, scale = 1): number {
  let cx = Math.round(x);
  const s = Math.max(1, Math.round(scale));
  for (const ch0 of text) {
    const ch = ch0.toUpperCase();
    const g = G[ch] ?? G['?'];
    for (let j = 0; j < 5; j++)
      for (let i = 0; i < 3; i++) if (g[j * 3 + i] === '1') px.rect(cx + i * s, Math.round(y) + j * s, s, s, color);
    cx += 4 * s;
  }
  return cx - Math.round(x) - s;
}

export function pixelTextWidth(text: string, scale = 1): number {
  return text.length * 4 * scale - scale;
}
